// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "bar-xinglet-843b477e/chunk-" + {"410": "3c048cc1c7216cdd","559": "a07a663d2e0e24e7","937": "18102db89c6b94a8",}[chunkId] + ".js"
}